import { detectBlackSpots } from '../utils/inspectCore';

let worker;
let workerFailed = false;
let seq = 0;

function getWorker() {
  if (workerFailed) return null;
  if (!worker) {
    try {
      worker = new Worker(new URL('../workers/inspectWorker.js', import.meta.url), {
        type: 'module',
      });
      worker.addEventListener('error', () => {
        workerFailed = true;
        worker = null;
      });
    } catch (err) {
      workerFailed = true;
      return null;
    }
  }
  return worker;
}

function runOnMainThread(imageData, options) {
  const started = performance.now();
  const result = detectBlackSpots(imageData, options);
  result.metrics.processingMs = Number((performance.now() - started).toFixed(1));
  return result;
}

export function runInspectionInWorker(imageData, options) {
  const w = getWorker();
  if (!w) {
    return Promise.resolve(runOnMainThread(imageData, options));
  }

  const id = ++seq;

  return new Promise((resolve) => {
    const onMessage = (event) => {
      if (!event.data || event.data.id !== id) return;
      w.removeEventListener('message', onMessage);
      if (event.data.ok) resolve(event.data.result);
      else {
        workerFailed = true;
        resolve(runOnMainThread(imageData, options));
      }
    };

    const onError = () => {
      w.removeEventListener('message', onMessage);
      w.removeEventListener('error', onError);
      workerFailed = true;
      resolve(runOnMainThread(imageData, options));
    };

    w.addEventListener('message', onMessage);
    w.addEventListener('error', onError);

    try {
      w.postMessage({ id, imageData, options });
    } catch (err) {
      w.removeEventListener('message', onMessage);
      w.removeEventListener('error', onError);
      workerFailed = true;
      resolve(runOnMainThread(imageData, options));
    }
  });
}

/**
 * Downscale large camera frames before CV to keep inspection fast on phones.
 */
export function prepareImageData(sourceCanvas, maxSide = 1280) {
  const scale = Math.min(1, maxSide / Math.max(sourceCanvas.width, sourceCanvas.height));
  const width = Math.max(1, Math.round(sourceCanvas.width * scale));
  const height = Math.max(1, Math.round(sourceCanvas.height * scale));

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  ctx.drawImage(sourceCanvas, 0, 0, width, height);
  return {
    imageData: ctx.getImageData(0, 0, width, height),
    width,
    height,
    scale,
  };
}
